import { ExportColumn } from '../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'supplierName',
    header: 'Supplier',
    type: 'text',
  },
  {
    key: 'supplierRecoveryTime',
    header: 'Recovery Time (Months)',
    type: 'number',
  },
  {
    key: 'sourcingStatus',
    header: 'Sourcing Status',
    type: 'text',
  },
  {
    key: 'timeToReplaceSupplier',
    header: 'Time to Replace Supplier (Months)',
    type: 'number',
    width: 40,
  },
  {
    key: 'availableAlternatives',
    header: 'Available Alternatives',
    type: 'text',
  },
  {
    key: 'qualifiedAlternatives',
    header: 'Qualified Alternatives',
    type: 'text',
  },
  {
    key: 'bcpUploaded',
    header: 'Supplier BCP Added',
    type: 'boolean',
  },
];
